import { Component } from '@angular/core';
import { MenuItem } from '../../../../../interfaces/menuItem';
import { SidebarItemsComponent } from '../sidebar-items/sidebar-items.component';

@Component({
	selector: 'app-sidebar-footer',
	standalone: true,
	imports: [SidebarItemsComponent],
	templateUrl: './sidebar-footer.component.html',
	styleUrl: './sidebar-footer.component.scss'
})
export class SidebarFooterComponent {
	menuItems: MenuItem[] = [
		{ id: 8, icon: 'edit', title: 'Editar mi perfil', url: 'edit' },
		{ id: 9, icon: 'logout', title: 'Cerrar sesión', url: 'login' }
	];
}
